module.exports = __webpack_public_path__ + "img/icn-Withdrawal-cd.186726ba.png";